import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FontIcon,
} from 'material-ui';
import R from 'ramda';
import LeftNavWidget from '../../../generic-components/left-nav-widget';
import AddProductButton from '../add-product-button';
import ErrorCheckIcon from '../../draftNTemplate-container/error-check-indicator-icon';
import { SmallFlatButton } from '../../../../tc-ui/small-buttons';
import RatePackageGroup from './rate-package-group';
import SortRatePackageGroupDialog from './sort-rate-package-group';

const propTypes = {
  contractId: PropTypes.string.isRequired,
  productsArray: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  changeLeftNavRoute: PropTypes.func.isRequired,
  supplierEditable: PropTypes.bool.isRequired,
  sortingProducts: PropTypes.func,
  locationId: PropTypes.string,
  productsErrors: PropTypes.array,
  thisProductId: PropTypes.string,
  collection: PropTypes.string,
  openAddProductDialog: PropTypes.func,
  openAddEditContractDialog: PropTypes.func,
};
const simpleStyle = { marginTop: '10px', marginLeft: '18px', padding: '0 4px 0 0' };
class LeftNavProducts extends Component {
  constructor() {
    super();
    this.state = {
      sortDialogOpen: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes);
    const update = (
      !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) ||
      !R.equals(this.state, nextState)
    );
    return update;
  }

  closeSortDialog = () => this.setState({ sortDialogOpen: false });

  saveSorted = (newArray) => {
    this.props.sortingProducts(newArray);
    this.setState({
      sortDialogOpen: false,
    });
  }
  render() {
    const {
      contractId,
      locationId,
      collection,
      productsArray,
      changeLeftNavRoute,
      supplierEditable,
      sortingProducts,
      productsErrors,
      location,
      thisProductId,
      openAddEditContractDialog,
    } = this.props;
    if (!locationId) return <div />;
    const groupedByProductId = R.groupBy(R.prop('productId'), productsArray);
    const { sortDialogOpen } = this.state;
    return (
      <div>
        <div className="flex-tc-sb" style={R.merge(simpleStyle, { fontWeight: 'bold' })}>
          Room/Product Rates
          {supplierEditable &&
            sortingProducts &&
            productsArray &&
            productsArray.length > 1 ? (
              <SmallFlatButton
                label="Reorder"
                onTouchTap={() => this.setState({ sortDialogOpen: true, sortType: 'products', sortProductId: '' })}
                secondary
                style={{ border: '1px solid rgba(0, 0, 0, 0.64)' }}
                labelStyle={{ padding: '4px 8px 4px 2px', color: 'rgba(0, 0, 0, 0.64)', top: '-1px' }}
                icon={(
                  <FontIcon
                    className="tc-icon-swap_vert"
                    style={{ color: 'rgba(0, 0, 0, 0.64)' }}
                  />
                )}
              />
            ) : (
              <div />
            )}
        </div>
        {R.isEmpty(productsArray) && (
          <div
            style={{
              marginLeft: '18px',
              display: 'flex',
              alignItems: 'center',
              color: '#f44336',
            }}
          >
            <ErrorCheckIcon showError />
            &nbsp; Please add a room/product
          </div>
        )}
        {
        /*
          raw data structure:
          [{ productId, ratePackageName, productName, ...etc }]
          groupedByProductId:
          {
            <productId>: [{ productId, ratePackageName, productName }]
          }
          we are rendering it this way:
          product name A (Not clickable, just a label)
          ratePackageName 1 (clickable)
          ratePackageName 2 (clickable)
          product name B (clickable)
        */
          R.keys(groupedByProductId).map(productId => {
            if (groupedByProductId[productId].length > 1) {
              const showErrorForProduct = groupedByProductId[productId].some(obj => {
                const percent = R.call(
                  R.compose(
                    foundProduct => (foundProduct ? foundProduct.percent : 100),
                    R.find(
                      productInError => productInError.ratePackageIndex
                        === obj.ratePackageIndex,
                    ),
                  ),
                  productsErrors,
                );
                return percent !== 100;
              });
              const ratePackages = groupedByProductId[productId];
              const { productName, ratePackageIndex } = groupedByProductId[productId][0];
              return (
                <RatePackageGroup
                  key={productId}
                  {...{
                    location,
                    productName,
                    thisProductId,
                    urlPartial: `/contracting/${collection}/${contractId}/product/${productId}`,
                    supplierEditable,
                    showErrorForProduct,
                    changeLeftNavRoute,
                    ratePackages,
                    productsErrors,
                    productId,
                    managePackages: () => openAddEditContractDialog({
                      type: 'manageRatePackage',
                      title: `Manage Rate Packages for ${productName}`,
                      data: { productId, ratePackageIndex },
                    }),
                  }}
                />
              );
            }
            const ratePackage = groupedByProductId[productId][0];
            const percent = R.call(
              R.compose(
                foundProduct => (foundProduct ? foundProduct.percent : 100),
                R.find(
                  productInError => productInError.ratePackageIndex
                    === ratePackage.ratePackageIndex,
                ),
              ),
              productsErrors,
            );
            const label = !supplierEditable ? (
              ratePackage.productName
            ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {supplierEditable && <ErrorCheckIcon showError={percent !== 100} />}
                  {ratePackage.productName}
                </div>
              );
            const ratePackageId = (() => {
              if (ratePackage._id) return ratePackage._id;
              return ratePackage.ratePackageName
              ? encodeURIComponent(ratePackage.ratePackageName)
              : 'Primary';
            })();
            return (
              <LeftNavWidget
                key={productId}
                routeName={`/contracting/${collection}/${contractId}/product/${productId}/${ratePackageId}`}
                name={label}
                onTouchTap={() => changeLeftNavRoute(
                  `/contracting/${collection}/${contractId}/product/${productId}/${ratePackageId}`,
                )
                }
              />
            );
          })
        }
        <SortRatePackageGroupDialog
          productsArray={productsArray}
          open={sortDialogOpen}
          onRequestClose={this.closeSortDialog}
          saveSorted={this.saveSorted}
        />
        {Boolean(supplierEditable) && (
          <AddProductButton
            openAddEditContractDialog={openAddEditContractDialog}
            productsArray={productsArray}
          />
        )}
      </div>
    );
  }
}

LeftNavProducts.defaultProps = {
  collection: '',
  thisProductId: '',
  productsErrors: [],
  openAddProductDialog: () => {},
  openAddEditContractDialog: () => {},
};

LeftNavProducts.propTypes = propTypes;
const mapStateToProps = ({ contracting }, props) => {
  const state = contracting.contractActivitiesProducts.toJS();
  const productsErrors = R.pathOr([], ['draftErrors', 'products'], state);
  const thisProductId = R.pathOr('', ['rightSideContent', 'productId'], state) || props.thisProductId;
  return ({ productsErrors, thisProductId });
};
export default connect(mapStateToProps)(LeftNavProducts);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/products/left-nav-products.jsx